import { Injectable } from '@angular/core';
import { Http, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs';
import {Utils} from './utils';

@Injectable()
export class HttpClientService {

  private baseURL = 'https://akceso07.nine.ch/mea';

  constructor(private http: Http) {

  }

  public post(url: string, body: any): Observable<Response> {

    if(!body) {
      body = {};
    }

    body['user'] = localStorage.getItem('mea_user');
    body['token'] = localStorage.getItem('mea_token');

    return this.http.post(this.getUrl(url), body)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private getUrl(url:string) {
    if(url.startsWith('/')) {
      return this.baseURL + url;
    } else {
      return this.baseURL + '/' + url;
    }
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/services/http-client.service.ts